export function getDestinationConfigFlatModel(destination) {
  return {
    id: destination.id,
    type: destination.type,
    ...destination.formData,
    ...(typeof destination.formData?.name === 'string' && { name: destination.formData.name.trim() })
  };
}
